import React from 'react';
import { ValidationError } from 'ui/common/validation-error/validation-error';
import { TextConfigurationTranslation } from '../../../constants';
import { TextListValidationError, TextListValidationItem } from '../types-store';

import styles from './text-list-validation-errors.scss';

interface TextListValidationErrorsProps {
  validationErrors: TextListValidationError[];
  translation: TextConfigurationTranslation;
}

export const TextListValidationErrors = ({ validationErrors, translation }: TextListValidationErrorsProps) => {

  if (!validationErrors || validationErrors.length === 0) {
    return null;
  }

  const buildValidationErrorItems = (error: TextListValidationItem) => <>
    <span className={styles.itemValue}>{error?.textSet?.d}</span>,
    {' '}<span className={styles.itemValue}>{error?.language?.d}</span>,
    {' '}{translation.texts}: {error?.id?.map((textId, index) =>
      <span key={index} className={styles.itemValue}>
        {index === error.id.length - 1 ? textId : `${textId}, `}
      </span>)}
  </>;

  return <div className={styles.container}>{validationErrors.map((error, index) =>
    <ValidationError
      key={index}
      title={error.message}
      subtitle={error.hint}
      items={error.errors?.map(buildValidationErrorItems)} />)}
  </div>;
};
